export const dashboardStats = {
  todayAppointments: 14,
  tomorrowAppointments: 22,
  todayCustomers: 12,
  noShowCustomers: 2,
  estimatedRevenue: 8500,
  actualRevenue: 6200,
  openPayment: 2300,
  activePackageCustomers: 47,
  lowSessionPackages: 8,
  peakHour: "14:00 - 16:00",
  googleSource: 6,
  metaSource: 4,
  whatsappSource: 3,
  repeatRate: 68,
};

export const dashboardAlerts = [
  {
    id: 1,
    type: "confirmation",
    title: "Bugün Teyit Bekleyen Randevular",
    count: 3,
    description: "3 randevu henüz teyit edilmedi",
    priority: "high",
  },
  {
    id: 2,
    type: "package",
    title: "Paketi Bitmek Üzere Olan Müşteriler",
    count: 5,
    description: "5 müşterinin paketinde 2 seanstan az kaldı",
    priority: "medium",
  },
  {
    id: 3,
    type: "payment",
    title: "Açık Ödeme Bulunan Müşteriler",
    count: 4,
    description: "Toplam 2.300 TL açık ödeme var",
    priority: "high",
  },
  {
    id: 4,
    type: "warning",
    title: "Sorunlu Müşteri Uyarısı",
    count: 1,
    description: "1 müşteri son 3 randevusuna gelmedi",
    priority: "high",
  },
  {
    id: 5,
    type: "panel",
    title: "Panel Kullanım Durumu",
    count: null,
    description: "Premium paket aktif - 12 gün kaldı",
    priority: "low",
  },
];

export const dailyRevenueChart = [
  { day: "Pzt", estimated: 4200, actual: 3800 },
  { day: "Sal", estimated: 5100, actual: 4500 },
  { day: "Çar", estimated: 3800, actual: 3200 },
  { day: "Per", estimated: 6200, actual: 5500 },
  { day: "Cum", estimated: 8500, actual: 6200 },
  { day: "Cmt", estimated: 9800, actual: 8500 },
  { day: "Paz", estimated: 7200, actual: 0 },
];

export const sourceDistribution = [
  { name: "Google", value: 28, color: "#2D5F3E" },
  { name: "Meta", value: 22, color: "#3B82F6" },
  { name: "WhatsApp", value: 18, color: "#10B981" },
  { name: "Tavsiye", value: 15, color: "#C9A962" },
  { name: "Tekrar", value: 17, color: "#8B5CF6" },
];

export const staffPerformance = [
  { name: "Ayşe K.", revenue: 12500, appointments: 45 },
  { name: "Mehmet S.", revenue: 10800, appointments: 38 },
  { name: "Zeynep D.", revenue: 9500, appointments: 34 },
  { name: "Burak T.", revenue: 8200, appointments: 30 },
  { name: "Elif Y.", revenue: 7400, appointments: 27 },
];

export const serviceDistribution = [
  { name: "Masaj", value: 35 },
  { name: "Cilt Bakımı", value: 22 },
  { name: "SPA Paket", value: 18 },
  { name: "Manikür", value: 12 },
  { name: "Pedikür", value: 8 },
  { name: "Diğer", value: 5 },
];

export const todayHourlyDensity = [
  { hour: "09:00", count: 2 },
  { hour: "10:00", count: 4 },
  { hour: "11:00", count: 3 },
  { hour: "12:00", count: 5 },
  { hour: "13:00", count: 3 },
  { hour: "14:00", count: 7 },
  { hour: "15:00", count: 6 },
  { hour: "16:00", count: 5 },
  { hour: "17:00", count: 4 },
  { hour: "18:00", count: 3 },
  { hour: "19:00", count: 2 },
  { hour: "20:00", count: 1 },
];

export const tomorrowHourlyDensity = [
  { hour: "09:00", count: 3 },
  { hour: "10:00", count: 5 },
  { hour: "11:00", count: 4 },
  { hour: "12:00", count: 6 },
  { hour: "13:00", count: 4 },
  { hour: "14:00", count: 8 },
  { hour: "15:00", count: 7 },
  { hour: "16:00", count: 6 },
  { hour: "17:00", count: 5 },
  { hour: "18:00", count: 4 },
  { hour: "19:00", count: 3 },
  { hour: "20:00", count: 2 },
];